// extracted by mini-css-extract-plugin
export default {"sort":"MU-z","sortSelect":"NU-z","disabled":"OU-z"};